import React from "react";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, Field, change } from "redux-form";
import { FormattedDate, FormattedNumber } from "react-intl";
import { MaterialTextField, MaterialCheckbox } from "./MaterialInput";
import { NewLoanTypes, Office } from "../constants/enums";
import * as agent from "../agent";
import { required, normalizeMoney } from "../utility";
import PickRatesInput from "./PickRatesInput";
import { calculateCommission, calculateLeasingTotalSum, generateLeasingPayments } from "../businessLogic";
import Collapse from '@material-ui/core/Collapse';
import MaterialSlider from './MaterialSlider';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';

class programDetailsForm extends React.Component {

    state = {
        managersLoaded: false,
        managers: []
    }

    componentWillMount = () => {
        const { isJur } = this.props;
        agent.User.managers(isJur)
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(e => alert(e.message));
    }

    prepareData = data => Object.assign(data,
        {
            sum: +(data.sum.replace(/\s/g,``)),
            duration: Number(data.duration),
            preliminaryPrice: +(data.preliminaryPrice.replace(/\s/g,``))
        },
        { loanTicket: data.programType === "HOLD_LT" ? [data.loanTicket] : undefined },
        { comission: (data.programType === "PTS" || data.programType === "PTS_LEASING") ? +(data.comission.replace(/\s/g,``)) : undefined }
    )
    recalculateCommission = (e) => {
        const { dispatch } = this.props;
        const s = +`${e.target.value}`.replace(/\s/g,``);
        dispatch(change("program-details-form", "comission", normalizeMoney(calculateCommission(s))));
    }
    recalculatePreferentialPeriod = (e) => {
        const { inputPreferentialPeriod, dispatch } = this.props;
        const p = +e.target.value;
        const iPP = +inputPreferentialPeriod;
        dispatch(change("program-details-form", "preferentialPeriod", p > iPP - 1 ? iPP : Math.round(p / 2)));
    }
    render() {
        const { contractId,
                inputProgram,
                inputPreferentialRepayment,
                inputPreferentialPeriod,
                inputIsLeasingPrepayed,
                inputSum,
                inputDuration,
                inputRates = [],
                chargeComission,
                isJur,
                onProgramDetailsSubmit,
                switchTab,
                handleSubmit } = this.props;
        const { managersLoaded, managers } = this.state;
        const isLT = inputProgram === "HOLD_LT";
        const isPTS = inputProgram === "PTS";
        const isLeasing = inputProgram === "PTS_LEASING";
        const date = new Date();
        const duration = +inputDuration || 0;
        const leasingRate = +inputRates[0] || 0;
        const totalSum = calculateLeasingTotalSum(inputSum, duration, leasingRate);
        const payments = generateLeasingPayments({
            date,
            duration,
            leasingRate,
            sum: inputSum,
            preferentialPeriod: inputPreferentialPeriod,
            isLeasingPrepayed: inputIsLeasingPrepayed,
            isPreferentialRepayment: inputPreferentialRepayment
        });
        const disabled = duration <= 0 || inputRates.length === 0 || inputSum === 0 || !inputProgram ;

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <form onSubmit={handleSubmit(data => onProgramDetailsSubmit(contractId, this.prepareData(data), () => switchTab(null, 3)))} className="program-details-form">
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            <Field name="programType"
                                   disabled={isJur ? true : false}
                                   validate={required}
                                   select
                                   onChange={this.recalculateCommission}
                                   component={MaterialTextField}
                                   label="Программа займа" >
                               {Object.keys(NewLoanTypes).filter(t => t !== "NOT_SURE").map((t, i) => <MenuItem key={i} value={t}>{NewLoanTypes[t]}</MenuItem>)}
                            </Field>
                            { isLT &&
                                <Field name="loanTicket"
                                       component={MaterialTextField}
                                       validate={required}
                                       label="Залоговый билет №" />
                            }
                             { isLT &&
                                 <Field name="preliminaryPrice"
                                        endAdornment="₽"
                                        format={normalizeMoney}
                                        component={MaterialTextField}
                                        validate={required}
                                        normalize={normalizeMoney}
                                        label="Оценочная стоимость"/> }
                            <Field component={MaterialTextField}
                                   name="sum"
                                   normalize={normalizeMoney}
                                   format={normalizeMoney}
                                   validate={required}
                                   endAdornment="₽"
                                   onChange={this.recalculateCommission}
                                   label="Сумма займа" />
                           { (isPTS || isLeasing) &&
                               <FormControlLabel
                                control={
                                    <Field name="chargeComission"
                                           component={MaterialCheckbox} />}
                                label="Удержать комиссию"/>
                           }
                           <Collapse in={(isPTS || isLeasing) && chargeComission} classes={{ container: "collapse-wrapper" }}>
                               <div className="common-form">
                                   <Field name="comission"
                                          component={MaterialTextField}
                                          disabled={false}
                                          endAdornment="₽"
                                          normalize={normalizeMoney}
                                          format={normalizeMoney}
                                          label="Комиссия"/>
                                </div>
                            </Collapse>
                            <Field component={MaterialTextField}
                                   name="duration"
                                   validate={required}
                                   onChange={this.recalculatePreferentialPeriod}
                                   select
                                   label="Срок займа" >
                                {isLeasing && <MenuItem value="3">3 мес.</MenuItem>}
                                {isLeasing && <MenuItem value="6">6 мес.</MenuItem>}
                                {isLeasing && Array(3).fill(0).map((_, i) => <MenuItem key={i} value={`${(i+1)* 12}`}>{(i+1)* 12} мес.</MenuItem>) }
                                {isLT && <MenuItem value="10">10 дн.</MenuItem>}
                                {isLT && <MenuItem value="30">30 дн.</MenuItem>}
                                {!isLeasing && !isLT && Array(36).fill(0).map((_, i) => <MenuItem key={i} value={`${i+1}`}>{i+1} мес.</MenuItem>)}
                            </Field>
                            <Field component={PickRatesInput}
                                   name="rates"
                                   duration={isLeasing ? 1 : inputDuration}
                                   sum={inputSum} />
                            <Field component={MaterialTextField}
                                   select
                                   name="manager"
                                   validate={required}
                                   disabled={!managersLoaded}
                                   label={isJur ? "Сторона договора" : "Ведущий менеджер" }>
                               {managers.map(({ _id, fullname}, i) => {
                                   const [ managerLastname, managerFirstname = "", managerThirdname = "" ] = fullname.split(" ");
                                   return <MenuItem key={i} value={_id}>{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</MenuItem>
                               })}
                            </Field>
                            <Field name="office"
                                   select
                                   component={MaterialTextField}
                                   validate={required}
                                   label="Офис" >
                               {Object.keys(Office).map((o, i) => <MenuItem key={i} value={o}>{Office[o]}</MenuItem>)}
                            </Field>
                        </Grid>
                        {isLeasing ?
                            inputDuration > 0 && inputRates.length > 0 ?
                                <Grid item className="common-form ultrawide-column">
                                    <Typography variant="h5" align="center">График платежей:</Typography>
                                    <FormControlLabel
                                         control={
                                             <Field name="isLeasingPrepayed"
                                                    component={MaterialCheckbox} />}
                                         label="Авансовый платеж"/>
                                    { isLeasing &&
                                        <FormControlLabel
                                         control={
                                             <Field name="preferentialRepayment"
                                                    component={MaterialCheckbox} />}
                                         label="Льготное погашение"/>
                                    }
                                    { isLeasing && inputPreferentialRepayment &&
                                        <Field component={MaterialSlider}
                                               name="preferentialPeriod"
                                               max={inputDuration - 1}/>
                                    }
                                    <Table padding="checkbox">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Дата платежа</TableCell>
                                                <TableCell>Сумма лизингового платежа за текущий период</TableCell>
                                                <TableCell>Размер выкупной цены в лизинговом платеже</TableCell>
                                                <TableCell>Сумма досрочного выкупа ТС, без учета очередного лизингового платежа</TableCell>
                                            </TableRow >
                                        </TableHead>
                                        <TableBody>
                                            {payments.map(({ paymentDate, paymentTotal, paymentCar, paymentBuyout }, i) =>
                                                <TableRow key={i}>
                                                    <TableCell>
                                                        <FormattedDate value={paymentDate}
                                                                       day="numeric"
                                                                       month="numeric"
                                                                       year="numeric" />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={paymentTotal}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={paymentCar}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={paymentBuyout}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell>Итого: </TableCell>
                                                <TableCell>
                                                    <FormattedNumber value={totalSum}
                                                                     style={`currency`}
                                                                     currency="RUB"
                                                                     minimumFractionDigits={0} />
                                                </TableCell>
                                                <TableCell>
                                                    <FormattedNumber value={inputSum}
                                                                     style={`currency`}
                                                                     currency="RUB"
                                                                     minimumFractionDigits={0} />
                                                </TableCell>
                                                <TableCell>
                                                    &nbsp;
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </Grid>
                                :
                                <Grid item className="common-form common-column">
                                    <Typography paragraph >Введите процентную ставку и срок займа</Typography>
                                </Grid>
                            :
                            <Grid item className="common-form common-column">
                                <Typography paragraph >Добавить сюда статичным текстом 'рекомендации' от СБ со второго шага?</Typography>
                            </Grid>
                        }
                    </Grid>
                    <Grid container spacing={16}>
                        <Grid item className="common-form common-column">
                            <Button fullWidth
                                    onClick={e => {
                                        e.preventDefault();
                                        switchTab(null, 1);
                                    }}
                                    size="large"
                                    variant="contained" >Назад</Button>
                        </Grid>
                        <Grid item className="common-form common-column">
                            <Button type="submit"
                                    fullWidth
                                    disabled={disabled}
                                    color="primary"
                                    className="common-submit"
                                    size="large"
                                    variant="contained" >Далее</Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        );
    }
}

const ProgramDetailsForm = connect(
    (state, props) => {
        const { car: { loan: {value, duration, office, type} = {} }, programDetails = {}, isJur } = props;
        const { programType, sum, preliminaryPrice } = programDetails;
        const isLT = (programType || type) === "HOLD_LT";
        const isLeasing = (programType || type) === "PTS_LEASING";
        const isPTS = (programType || type) === "PTS";

        return {
            managers: state.users.managers,
            inputIsLeasingPrepayed: formValueSelector("program-details-form")(state, "isLeasingPrepayed"),
            inputPreferentialRepayment: formValueSelector("program-details-form")(state, "preferentialRepayment"),
            inputPreferentialPeriod: +formValueSelector("program-details-form")(state, "preferentialPeriod"),
            inputRates: formValueSelector("program-details-form")(state, "rates"),
            inputSum: +`${formValueSelector("program-details-form")(state, "sum")}`.replace(/\s/g,``),
            inputProgram: formValueSelector("program-details-form")(state, "programType"),
            inputDuration: formValueSelector("program-details-form")(state, "duration"),
            chargeComission: formValueSelector("program-details-form")(state, "chargeComission"),
            initialValues: Object.assign(
                {
                    programType: isJur ? "HOLD" : type,
                    manager: state.common.user.id,
                    chargeComission: true,
                    office: ["MOSCOW","NEWCHERKASSKY"].includes(office) ? office : "",
                    rates: programDetails.rates || []
                },
                programDetails,
                {
                    duration: String(isLT ? 30 : (programDetails.duration || duration || 0)),
                    sum: normalizeMoney(sum || value),
                    preliminaryPrice: normalizeMoney(preliminaryPrice)
                },
                ( (isPTS || isLeasing) ? {comission: normalizeMoney(calculateCommission(sum || value)) } : {} )
            ),
        };
    },
    null
)(reduxForm({
    form: "program-details-form",
    enableReinitialize: true,
})(programDetailsForm));

export default ProgramDetailsForm;



// WEBPACK FOOTER //
// ./src/components/ProgramDetailsForm.js